/**
 * Thin adapter: exposes SDK risk service (standalone risk list UI removed).
 */
export class RiskIntegration {
    constructor(sdkService) {
        this.service = sdkService;
    }

    /**
     * GET /risk/monitoring — same auth/tenant pipeline as home (`sdk` + axios interceptors).
     */
    async fetchMonitoringData() {
        return this.service.getMonitoring({});
    }
}
